import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {Observable, Subject} from 'rxjs';
import {QueryProvider} from '@shared/queries/query-provider';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {UpdateSurveyDataItemCommand} from '../../commands/survey.commands';
import {takeUntil} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {Guid} from 'guid-typescript';
import {skip} from 'rxjs/operators';
import { DialogService } from '@shared/services/dialog-service';
import {Configuration} from '@shared/models/configuration';
import {CaseType, Dac6FieldConfigKeys} from '../../../dac6-reporter/Fields';
import {DataSurveyFieldConfigKeys} from '../../DataSurvey';

@Component({
    standalone: false,
    selector: 'particle-data-survey-response-form-view',
  templateUrl: './data-survey-response-form-view.component.html',
  styleUrls: ['./data-survey-response-form-view.component.scss']
})
export class DataSurveyResponseFormViewComponent implements OnInit, OnChanges, OnDestroy {
  saveDynmaicC: any;
  isDirty: boolean;
  @Input() itemId: string;
  @Input() surveyId: string;
  @Input() executionId: string;
  @Input() userExecutionId: string;
  @Input() sourceType: string;
  @Input() userId: string;
  @Input() sectionType: string;
  @Output() saveChanged: EventEmitter<any> = new EventEmitter<any>();
  unsubscibes$ = new Subject<void>();
  endpointName: string = 'DataSurveyApi';
  showDelete: boolean = false;
  invalidateSubject = new InvalidateSubject();
  showLanguageOption: false;
  editedFields: string[] = [];
  private detailResponse$: Observable<any>;
  item: any;
  formField: any;
  containerClass = 'content';
  fieldConfig: any;
  unSavedItemValue = {};
  dynamicFieldInitialValues = {};
  formSaveChanged = false;
  isDynamicValueChangted = false;
  isInitialValueSaved = {};
  isPreviousValueReloaded = true;
  constructor(public queryState: Store<IQueryState>,
              private commandService: CommandService,
              private dialogService: DialogService, ) {

  }

  ngOnInit() {
    this.invalidateSubject.getObservale().pipe(takeUntil(this.unsubscibes$)).subscribe(state => {
      if (state.indexOf('SaveChangesOnPageChangeOrTab') >= 0) {
        if (this.editedFields.length > 0) {this.save(); }
      }
    });
    this.detailResponse$ = this.queryState.pipe(select(getQueryResponse, 'SurveyDetailViewResponse'), skip(1));
    this.detailResponse$.subscribe(state => {
      if (state && state.formField && state.item) {
        console.log('detailResponse$', state);
        this.item = state.item;

        if (this.sectionType && this.sectionType === CaseType.Arrangement) {
          const config = Configuration.getSmartGridConfig(DataSurveyFieldConfigKeys.ArrangmentAEFieldConfigKey);
          config.Parameters['ID'] = this.item.id;
        }

        this.saveDynamicValues();
        if (!this.isPreviousValueReloaded) {
          this.reloadUnsavedItem();
        }
        this.formField = state.formField;
        this.fieldConfig = state.fieldConfig;
        if (this.formField.viewType === 'Tab') {
          this.containerClass = 'content';
        } else {
          this.containerClass = 'content m-30';
        }
      }
    });
  }

  onValueChanged(event) {
    console.log('onValueChanged', event);
    if (event) {
      switch (event.action) {
        case 'ValueChanged':
          this.markAsEdited(event.event);
          break;
        case 'Edit':
          this.markAsEdited(event.event);
          break;
        case 'Refresh':
          QueryProvider.invokeQuery(this.queryState, 'SurveyDetailViewResponse', {
            '[SurveyId]': this.surveyId,
            '[ItemId]': this.itemId
          });
          this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
          break;
      }
    }
  }
  markAsEdited(event) {
    if (event && event.item && event.fieldDefinition) {
      const fieldKey = event.fieldDefinition.key;
      if (fieldKey === 'ReportingEntity') {
        this.saveReportingEntity(event);
      } else if (!this.editedFields.find(o => o === fieldKey)) {
        this.editedFields.push();
      }
      if (!this.isInitialValueSaved[fieldKey]) {this.unSavedItemValue[fieldKey] = event.item.cells[fieldKey]; }
      this.isDirty = true;
    }
  }
  saveReportingEntity(event: any) {
    this.isDynamicValueChangted = true;
    const item = {id: this.item.id, fieldValues: {}, executionId: this.executionId};
    const value = event.item.cells[event.fieldDefinition.key].value;
    item.fieldValues[event.fieldDefinition.key] = value;
    const command = new UpdateSurveyDataItemCommand(item, this.surveyId, this.userExecutionId, this.sourceType, this.userId);
    this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
      console.log('Command State', commandState);
      QueryProvider.invokeQuery(this.queryState, 'SurveyDetailViewResponse', {
          '[SurveyId]': this.surveyId,
          '[ItemId]': this.itemId
        }
      );
      this.isPreviousValueReloaded = false;
      this.invalidateSubject.invalidate();
    });
  }
  save() {
    this.formSaveChanged = true;
    if (this.editedFields.length) {
      const item = {id: this.item.id, fieldValues: {}, executionId: this.executionId};
      this.editedFields.forEach(key => {
        const value = this.item.cells[key].value;
        item.fieldValues[key] = value;
      });
      const command = new UpdateSurveyDataItemCommand(item, this.surveyId, this.userExecutionId, this.sourceType, this.userId);
      this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
        console.log('Command State', commandState);
        this.invalidateSubject.invalidate();
        this.isDirty = false;
        this.editedFields.splice(0, this.editedFields.length);
        this.saveChanged.emit(true);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemId || changes.surveyId) {
      if (this.isDynamicValueChangted) {
        this.revertBackDynamicFieldValues().subscribe(commandState => {
          this.initiateForm();
          QueryProvider.invokeQuery(this.queryState, 'SurveyDetailViewResponse', {
                '[SurveyId]': this.surveyId,
                '[ItemId]': this.itemId
              }
          );
          this.invalidateSubject.invalidate();
        });
      } else {
        this.initiateForm();
        QueryProvider.invokeQuery(this.queryState, 'SurveyDetailViewResponse', {
            '[SurveyId]': this.surveyId,
            '[ItemId]': this.itemId
          }
        );
      }
    }
  }

  private initiateForm() {
    this.isPreviousValueReloaded = true;
    this.dynamicFieldInitialValues = {};
    this.isInitialValueSaved = {};
    this.isDynamicValueChangted = false;
    this.editedFields = [];
  }

  private reloadUnsavedItem() {
    Object.keys(this.unSavedItemValue).forEach(key => {
      // this.item.cells[key]=JSON.parse(JSON.stringify(this.unSavedItemValue[key]));
      this.item.cells[key] = this.unSavedItemValue[key];
    });
    this.isPreviousValueReloaded = true;
    this.unSavedItemValue = {};
  }
  ngOnDestroy(): void {
   if (this.isDynamicValueChangted) {
     this.revertBackDynamicFieldValues().subscribe(commandState => {
       this.invalidateSubject.invalidate();
       this.initiateForm();
     });
   }
  }

  private revertBackDynamicFieldValues() {
    const item = {id: this.item.id, fieldValues: {}, executionId: this.executionId};
    Object.keys(this.dynamicFieldInitialValues).forEach(key => {
      item.fieldValues[key] = this.dynamicFieldInitialValues[key] ?
        this.dynamicFieldInitialValues[key].value : null;
    });
    const command = new UpdateSurveyDataItemCommand(item, this.surveyId, this.userExecutionId, this.sourceType, this.userId);
    return this.commandService.executeCommand(command);
  }

  private saveDynamicValues() {
    if (!this.isInitialValueSaved['ReportingEntity']) {
      this.isInitialValueSaved['ReportingEntity'] = true;
      this.dynamicFieldInitialValues['ReportingEntity'] = this.item.cells['ReportingEntity'] ?
        JSON.parse(JSON.stringify(this.item.cells['ReportingEntity'])) : null;
    }
  }
}
